import wx from "weixin-js-sdk";
const WebViewEnv = {
  WAP: "WAP",
  IOS: "IOS",
  Android: "Android",
  Harmony: 'Harmony',
  miniprogram: "miniprogram",
};

export function getWebViewEnv() {
  let result = WebViewEnv.WAP;
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (
    navigator.userAgent.includes("from=app") ||
    navigator.userAgent.includes("from=brokerapp") ||
    navigator.userAgent.includes("xiangyuapp")
  ) {
    const isHarmonyOS = navigator.userAgent.includes('OpenHarmony');
    result = isIOS ? WebViewEnv.IOS : ( isHarmonyOS ? WebViewEnv.Harmony : WebViewEnv.Android );
    return result;
  } else {
    if (navigator.userAgent.includes("miniProgram")) {
      result = WebViewEnv.miniprogram;
      return result;
    }
    return result;
  }
}

export function launchChatActionCallBack(params) {
  const webViewEnv = getWebViewEnv();
  if (webViewEnv === WebViewEnv.IOS) {
    window.launchCardChatCallBack(
      params.brokerName,
      params.phone,
      params.brokerId,
      params.brokerImg,
      params.cityId,
      "",
      params.msg
    );
  } else if (webViewEnv === WebViewEnv.Android) {
    window.android.launchCardChatCallBack(
      params.brokerName,
      params.phone,
      params.brokerId,
      params.brokerImg,
      params.cityId,
      "",
      params.msg
    );
  } else if (webViewEnv === WebViewEnv.Harmony) {
    window.android.launchChatActionCallBack(JSON.stringify({
      brokerName: params.brokerName,
      brokerPhone: params.phone,
      brokerID: params.brokerId,
      brokerCoverImage: params.brokerImg,
      brokerCityID: params.cityId,
      chatMsg: params.msg,
    }))
  } else if (webViewEnv === WebViewEnv.miniprogram) {
    wx.miniProgram.navigateTo({
      url: `/packages/im/page/detail/index?bid=${params.brokerId}&cityId=${
        params.cityId
      }&autoWord=${encodeURIComponent(params.msg)}`,
    });
  } else {
    console.log("wap跳转im聊天");
  }
  console.log("小程序跳转im聊天", params);
}

export function goBrokerDetail(params) {
  const { brokerid, brokerCityID } = params;
  const webViewEnv = getWebViewEnv();
  if (webViewEnv === WebViewEnv.IOS) {
    window.launchBrokerDetailActionWithCallBack &&
      window.launchBrokerDetailActionWithCallBack(
        brokerid,
        Number(brokerCityID)
      );
  } else if (webViewEnv === WebViewEnv.Android) {
    window.android.launchBrokerDetailActionWithCallBack &&
      window.android.launchBrokerDetailActionWithCallBack(
        brokerid,
        Number(brokerCityID)
      );
  } else if (webViewEnv === WebViewEnv.miniprogram) {
    wx.miniProgram.navigateTo({
      url: `/pages/broker_detail/brokerDetail?brokerId=${params.brokerid}&cityId=${params.brokerCityID}`,
      // url: `/pages/broker_detail/brokerDetail?brokerId=8225174&cityId=1`,
    });
  } else {
    console.log("wap跳转经纪人详情");
  }
}
